<template>
  <div class="login-options">
    <b-container class="content">
      <ApplicationLoginEmailCard
        @authInitiated="email => $emit('authInitiated', email)"
        :isResume="isResume"
        :initial-email="initialEmail"
        :read-only="readOnly"
      />
    </b-container>
  </div>
</template>

<script>
import ApplicationLoginEmailCard from './ApplicationLoginEmailCard'
import ApplicationLoginCard from './ApplicationLoginCard'

export default {
  name: 'ApplicationLoginOptions',
  components: {
    ApplicationLoginEmailCard,
    ApplicationLoginCard
  },
  props: {
    isResume: {
      type: Boolean,
      default: false
    },
    initialEmail: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.login-options {
  position: relative;
  top: $header-height;
  margin-bottom: 3rem;
  padding-bottom: 3rem;

  &__card-separator {
    color: $color-primary;
    font-weight: 700;
    line-height: 1.2;
    margin: 3rem 0;
    text-align: center;
    font-size: 2.2rem;
  }

  .content {
    margin: 0 auto;

    &.container {
      padding: 40px 15px 15px;
    }
  }
}
</style>
